(function () {
  'use strict';

  var ScratchCard = ScratchCardLib.ScratchCard;
  var SCRATCH_TYPE = ScratchCardLib.SCRATCH_TYPE;

  window.ReformlyScratchCard = {
    init: function (config) {
      var sectionId = config.sectionId;
      var overlay = document.getElementById('rsc-overlay-' + sectionId);
      if (!overlay) return;

      var isInline = config.triggerType === 'inline';

      // Check if already shown (persists until storage cleared) — skip for inline mode
      if (!isInline && localStorage.getItem('rsc_shown_' + sectionId)) return;

      var closeBtn = overlay.querySelector('.rsc-close');
      var form = document.getElementById('rsc-form-' + sectionId);
      var currentStep = 1;

      // ---- Fetch visitor location from IP ----
      config.location = { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone };
      fetch('https://ipapi.co/json/')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          config.location.country = data.country_name;
          config.location.city = data.city;
          config.location.countryCode = data.country_code;
          config.location.latitude = data.latitude;
          config.location.longitude = data.longitude;
          config.location.timezone = data.timezone || config.location.timezone;
          config.location.currency = data.currency;
          config.location.ip = data.ip;
        })
        .catch(function () { });

      // Dynamic discount text removed — hardcoded in HTML

      // ---- Klaviyo event tracking ----
      function trackEvent(name, props) {
        var data = props || {};
        data.source = 'Scratch Card Popup';
        if (config.location) {
          data.country = config.location.country;
          data.city = config.location.city;
          data.country_code = config.location.countryCode;
          data.currency = config.location.currency;
        }
        if (window._learnq) {
          window._learnq.push(['track', name, data]);
        }
        if (window.posthog) {
          window.posthog.capture(name, data);
        }
      }

      // ---- Show popup based on trigger ----
      function preventTouchMove(e) {
        if (e.touches.length <= 1) {
          e.preventDefault();
        }
      }

      function measurePopup() {
        var popup = overlay.querySelector('.rsc-popup');
        var panel = overlay.querySelector('.rsc-popup__panel');
        if (!panel) return;

        if (window.innerWidth >= 750) {
          // Desktop: scale 1440×1024 popup to fit viewport with 5% horizontal / 10% vertical margins
          if (!popup) return;
          var scale = Math.min(window.innerWidth * 0.96 / 1440, window.innerHeight * 0.9 / 1024, 1);
          popup.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
        } else {
          // Mobile: scale 440-wide panel to fit viewport width
          var mobileScale = Math.min(window.innerWidth / 440, 1);
          var vh = window.innerHeight;
          var panelHeight = Math.max(956, Math.ceil(vh / mobileScale));
          panel.style.height = panelHeight + 'px';
          panel.style.transform = 'translateX(-50%) scale(' + mobileScale + ')';
        }
      }

      window.addEventListener('resize', measurePopup);

      function showPopup() {
        overlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        overlay.addEventListener('touchmove', preventTouchMove, { passive: false });
        requestAnimationFrame(function () {
          overlay.classList.add('rsc-overlay--visible');
          measurePopup();
        });
        if (!isInline) {
          localStorage.setItem('rsc_shown_' + sectionId, '1');
        }
        trackEvent('Scratch Card Shown');
        initScratchCard();
      }

      if (isInline) {
        // Inline mode: init scratch card immediately, already visible
        initScratchCard();
      } else if (config.triggerType === 'delay') {
        setTimeout(showPopup, config.triggerDelay * 1000);
      } else if (config.triggerType === 'exit') {
        document.addEventListener('mouseout', function handler(e) {
          if (e.clientY < 5) {
            document.removeEventListener('mouseout', handler);
            showPopup();
          }
        });
        // Mobile fallback: delay
        if ('ontouchstart' in window) {
          setTimeout(showPopup, config.triggerDelay * 1000);
        }
      } else if (config.triggerType === 'scroll') {
        var scrollHandler = function () {
          var scrollPercent = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
          if (scrollPercent >= 50) {
            window.removeEventListener('scroll', scrollHandler);
            showPopup();
          }
        };
        window.addEventListener('scroll', scrollHandler, { passive: true });
      }

      // ---- Close popup ----
      function closePopup() {
        overlay.classList.remove('rsc-overlay--visible');
        document.body.style.overflow = '';
        overlay.removeEventListener('touchmove', preventTouchMove);
        setTimeout(function () {
          overlay.style.display = 'none';
        }, 300);
      }

      closeBtn.addEventListener('click', closePopup);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closePopup();
      });

      // ---- Step transitions ----
      function goToStep(step) {
        var activeStep = overlay.querySelector('.rsc-step--active');
        if (activeStep) {
          activeStep.classList.remove('rsc-step--active');
        }
        currentStep = step;
        var nextStep = overlay.querySelector('[data-step="' + step + '"]');
        nextStep.classList.add('rsc-step--active', 'rsc-step--entering');
        setTimeout(function () {
          nextStep.classList.remove('rsc-step--entering');
        }, 400);

        // Adjust shared logo spacing per step and hide on step 3
        var sharedLogo = overlay.querySelector('.rsc-popup__panel > .rsc-brand');
        if (sharedLogo) {
          if (step === 2 && window.innerWidth < 750) {
            sharedLogo.style.marginTop = '242px';
            sharedLogo.style.marginBottom = '31px';
          } else if (step === 2 && window.innerWidth >= 750) {
            sharedLogo.style.marginTop = '256px';
            sharedLogo.style.marginBottom = '68px';
          } else if (step === 3 && window.innerWidth < 750) {
            sharedLogo.style.marginTop = '210px';
            sharedLogo.style.marginBottom = '35px';
          } else if (step === 3 && window.innerWidth >= 750) {
            sharedLogo.style.marginTop = '209px';
            sharedLogo.style.marginBottom = '68px';
          } else if (step === 1) {
            sharedLogo.style.marginTop = '';
            sharedLogo.style.marginBottom = '';
          }
        }
      }

      // ---- Claim button → step 2 (email capture) ----
      var claimBtn = overlay.querySelector('[data-action="claim"]');
      if (claimBtn) {
        claimBtn.addEventListener('click', function () {
          trackEvent('Scratch Card Claim Clicked');
          goToStep(2);
        });
      }

      // ---- Copy discount code ----
      var copyBtn = overlay.querySelector('.rsc-code-copy');
      var codeText = overlay.querySelector('.rsc-code-text');
      function copyCode() {
        if (codeText) {
          navigator.clipboard.writeText(codeText.textContent.trim());
          showCopyToast();
        }
      }

      function showCopyToast() {
        var existing = overlay.querySelector('.rsc-toast');
        if (existing) existing.remove();
        var toast = document.createElement('div');
        toast.className = 'rsc-toast';
        toast.textContent = 'Copied to clipboard';
        overlay.appendChild(toast);
        requestAnimationFrame(function () {
          toast.classList.add('rsc-toast--visible');
        });
        setTimeout(function () {
          toast.classList.remove('rsc-toast--visible');
          setTimeout(function () { toast.remove(); }, 300);
        }, 3000);
      }
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          copyCode();
          trackEvent('Scratch Card Code Copied');
        });
      }

      // ---- Claim Now button → copy code + close ----
      var claimNowBtn = overlay.querySelector('[data-action="claim-now"]');
      if (claimNowBtn) {
        claimNowBtn.addEventListener('click', function () {
          copyCode();
          trackEvent('Scratch Card Claim Now Clicked');
          closePopup();
        });
      }

      // ---- Form submit → Klaviyo + step 4 ----
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = form.querySelector('input[name="email"]').value;
          if (!email) return;

          var submitBtn = form.querySelector('.rsc-btn');
          submitBtn.textContent = 'UNLOCKING...';
          submitBtn.disabled = true;

          subscribeToKlaviyo(email, config.klaviyoListId, function (success) {
            if (success) {
              if (window._learnq) {
                var identifyData = { '$email': email };
                if (config.location) {
                  identifyData['$city'] = config.location.city;
                  identifyData['$country'] = config.location.country;
                }
                window._learnq.push(['identify', identifyData]);
              }
              trackEvent('Scratch Card Email Submitted', { email: email });
              if (window.posthog) {
                window.posthog.identify(email, {
                  email: email,
                  city: config.location.city,
                  country: config.location.country
                });
              }
              updateKlaviyoProfile(email);
              if (config.discountCode) {
                applyDiscount(config.discountCode);
              }
              goToStep(3);
            } else {
              submitBtn.textContent = 'Try Again';
              submitBtn.disabled = false;
            }
          });
        });
      }

      // ---- Scratch card via scratchcard-js ----
      function initScratchCard() {
        var container = overlay.querySelector('.rsc-card');
        if (!container) return;

        var scratchText = overlay.querySelector('.rsc-card__scratch-text');
        var revealed = false;

        container.style.visibility = 'hidden';

        var sc = new ScratchCard(container, {
          scratchType: SCRATCH_TYPE.LINE,
          containerWidth: container.offsetWidth,
          containerHeight: container.offsetHeight,
          imageForwardSrc: config.goldImageUrl,
          htmlBackground: '<div></div>',
          clearZoneRadius: 30,
          percentToFinish: 15,
          enabledPercentUpdate: true,
          callback: function () {
            if (!revealed) {
              revealed = true;
              trackEvent('Scratch Card Revealed');
              var claimBtnEl = overlay.querySelector('.rsc-btn--claim');
              if (claimBtnEl) {
                setTimeout(function () {
                  claimBtnEl.classList.add('rsc-btn--visible');
                }, 400);
              }
            }
          }
        });

        sc.init().then(function () {
          container.style.visibility = 'visible';
          // Override mousePosition to fix coordinates inside CSS-scaled parents.
          // Library default uses offsetLeft/offsetTop which ignore CSS transforms.
          sc.mousePosition = function (evt) {
            var rect = sc.canvas.getBoundingClientRect();
            var scaleX = sc.canvas.width / rect.width;
            var scaleY = sc.canvas.height / rect.height;
            var cx, cy;
            if (evt.type.indexOf('touch') !== -1) {
              cx = evt.touches[0].clientX;
              cy = evt.touches[0].clientY;
            } else {
              cx = evt.clientX;
              cy = evt.clientY;
            }
            return [
              (cx - rect.left) * scaleX - sc.config.clearZoneRadius,
              (cy - rect.top) * scaleY - sc.config.clearZoneRadius
            ];
          };
          sc.canvas.addEventListener('scratch.move', function () {
            if (!revealed && scratchText) {
              scratchText.classList.add('rsc-hidden');
            }
          });
        }).catch(function (err) {
          console.warn('Scratch card init failed:', err);
          // Fallback: show claim button
          var claimBtnEl = overlay.querySelector('.rsc-btn--claim');
          if (claimBtnEl) claimBtnEl.classList.add('rsc-btn--visible');
        });
      }

      // ---- Klaviyo subscription ----
      function subscribeToKlaviyo(email, listId, callback) {
        if (!listId) {
          callback(true);
          return;
        }

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Scratch Card Popup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        };

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + config.klaviyoCompanyId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            callback(res.ok || res.status === 202);
          })
          .catch(function () {
            fallbackKlaviyoSubscribe(email, listId, callback);
          });
      }

      function fallbackKlaviyoSubscribe(email, listId, callback) {
        var formData = new FormData();
        formData.append('email', email);
        formData.append('g', listId);

        fetch('https://manage.klaviyo.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          body: formData
        })
          .then(function () {
            callback(true);
          })
          .catch(function () {
            callback(false);
          });
      }

      // ---- Update Klaviyo profile with location ----
      function updateKlaviyoProfile(email) {
        if (!config.klaviyoCompanyId || !config.location) return;

        var payload = {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              location: {
                city: config.location.city,
                country: config.location.country,
                timezone: config.location.timezone,
                latitude: config.location.latitude || null,
                longitude: config.location.longitude || null,
                ip: config.location.ip || null
              }
            }
          }
        };

        fetch('https://a.klaviyo.com/client/profiles/?company_id=' + config.klaviyoCompanyId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify(payload)
        }).catch(function () { });
      }

      // ---- Auto-apply discount ----
      function applyDiscount(code) {
        if (!code) return;
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () {
            // Trigger cart re-render so discounted prices show
            if (window.liquidAjaxCart && window.liquidAjaxCart.update) {
              window.liquidAjaxCart.update({});
            } else {
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({})
              }).catch(function () { });
            }
          })
          .catch(function () { });
      }
    }
  };
})();
